import { download, post, search } from '../../helpers/api';

export const SERVICE_URI = '/taxonomies';
export const BASE_VW_URI = '/api/v1/vw-pos-status';
export const POS_STATUS_BASE__URI = '/api/v1/pos/status';

export const downloadOnlyPosesData = async (spec) =>
  download(`${SERVICE_URI}/${BASE_VW_URI}`, spec, {}, true);

export const getPosesData = async (data) =>
  search(`${SERVICE_URI}${BASE_VW_URI}`, data);

export const upatePosStatus = async (posStatus) =>
  post(`${SERVICE_URI}${POS_STATUS_BASE__URI}/update`, posStatus);
